export const vipClientValues = [
  { icon: "❌", label: "No", value: "No" },
  { icon: "📌", label: "Importante", value: "Importante" },
  { icon: "⭐", label: "VIP", value: "Si" },
]